const esp = {
  free: 'Gratis',
  low: 'Carga pública de SMUD: $0.25/kWh',
  mid: 'Otro tipo de carga pública: $0.50/kWh',
  midUp: 'Otro tipo de carga pública: $0.75/kWh',
  high: 'Otro tipo de carga pública: $1.00/kWh',
  compareVehicles: 'Comparar vehículos',
  incentives: 'Incentivos',
  chargingStations: 'Estaciones de carga',
  dealers: 'Distribuidores',
  electricians: 'Electricistas',
  'evsCatalog.title': 'Descubre los vehículos eléctricos',
  'evsCatalog.subtitle':
    'Hay más vehículos eléctricos que nunca antes. Encuentra el tuyo hoy mismo.',
  electricity: 'Electricidad',
  gasoline: 'Gasolina',
  total: 'Total',
  description: 'Descripción',
  charging: 'Cargando',
  emissions: 'Emisiones',
  source: 'Fuente',
  vehicles: 'Vehículos',
  all: 'Todos',
  applyFilters: 'Aplicar filtros',
  age: 'Edad',
  zipcode: 'Código postal',
  personalizeIncentives: 'Personalizar los incentivos',
  'FAQ.subtitle':
    'Los vehículos eléctricos (EV) aún son nuevos y es natural tener preguntas. Encuentra las respuestas a continuación.',
  'vehicle.miles': 'millas',
  'vehicle.trees': 'árboles',
  'vehicle.view': 'Ver',
  'vehicle.more': 'más',
  'vehicle.fewer': 'menos',
  'vehicle.greater': 'mayor',
  'vehicle.plugInHybrid': 'Híbrido enchufable',
  'vehicle.allElectric': 'Todo eléctrico',
  'vehicle.gas': 'Gasolina',
  'vehicle.afterIncentives': 'Después de los incentivos',
  'vehicle.msrp': 'Precio de venta sugerido por el fabricante (MSRP)',
  'vehicle.estimatedIncentives': 'Incentivos estimados',
  'vehicle.offMSRP': '{msrp} de descuento sobre el MSRP',
  'vehicle.downPaymentMonth': 'durante {months} meses',
  'vehicle.downPayment': '+ {downPayment} de pago inicial',
  'vehicle.plusTax': 'más impuestos',
  'vehicle.type': 'Tipo',
  'vehicle.subtype': 'Subtipo',
  'vehicle.gvwr': 'GVWR',
  'vehicle.gvwr.value': '{value} lb',
  'vehicle.weightClass': 'Clase de peso',
  'vehicle.drivetype': 'Tren de transmisión',
  'vehicle.transmission': 'Transmisión',
  'vehicle.transmission.automatic': 'Automático',
  'vehicle.payload': 'Carga útil',
  'vehicle.seats': 'Asientos',
  'vehicle.cargoSpace': 'Espacio de carga',
  'vehicle.cargoSpace.value': '{cargoSpace} pies cúbicos',
  'vehicle.batteryCapacity': 'Capacidad de la batería',
  'vehicle.batteryCapacity.value': '{batteryCapacity} kWh',
  'vehicle.electricEfficiency.value': '{electricEfficiency} MPGe',
  'vehicle.gasEfficiency': 'Eficiencia de la gasolina',
  'vehicle.gasEfficiency.value': '{gasEfficiency} MPG',
  'vehicle.electricRange': 'Autonomía eléctrica',
  'vehicle.electricRange.value': '{electricRange} millas',
  'vehicle.totalRange': 'Autonomía total',
  'vehicle.totalRange.value': '{totalRange} millas',
  'vehicle.maxACChargeRate': 'Tasa máxima de carga en corriente alterna (AC)',
  'vehicle.maxACChargeRate.value': '{maxACChargeRate} kW',
  'vehicle.maxDCChargeRate': 'Tasa máxima de carga en corriente continua (DC)',
  'vehicle.maxDCChargeRate.value': '{maxDCChargeRate} kW',
  'vehicle.chargeTimeLevel2': 'Tiempo de carga - nivel 2',
  'vehicle.chargeTimeDC': 'Tiempo de carga - DC',
  'vehicle.plugTypes': 'Tipos de enchufe',
  'vehicle.fuelType': 'Tipo de combustible',
  'vehicle.batterySize': 'Tamaño de la pila',
  'vehicle.timeToChargeLvlTwo': 'Tiempo que tarda en cargarse - nivel 2',
  'vehicle.milesPerThirtyFastCharge': 'Milla por 30 minutos de carga rápida',
  'vehicle.coTwoEmissions': 'Reducción de emisiones de Co2',
  'vehicle.phev': 'Electricidad y gasolina',
  'vehicle.bev': 'Electricidad',
  'vehicle.age.one': '0 a 1 año',
  'vehicle.age.two': '2 a 3 años',
  'vehicle.age.four': '4 años o más',
  'vehicle.power.all': 'Todos',
  'vehicle.power.high': 'Alto',
  'vehicle.power.public': 'Público',
  'vehicle.power.other': 'Otros',
  'vehicle.type.sedan': 'Sedán',
  'vehicle.type.hatchback': 'Con portón trasero',
  'vehicle.type.coupe': 'Cupé',
  'vehicle.type.crossover': 'Crossover',
  'vehicle.type.minivan': 'Miniván',
  'vehicle.type.suv': 'Camioneta',
  'vehicle.type.wagon': 'Vagoneta',
  'vehicle.type.truck': 'Camión',
  'header.electricVehicles': 'Buscar EV',
  'header.compareVehicles': 'Comparar vehículos',
  'header.incentives': 'Incentivos',
  'header.charging': 'Cargando',
  'header.vehicleCatalog': 'Catálogo de EV',
  'header.inventory': 'Navegador de inventario de EV',
  'header.chargingStations': 'Mapa de estaciones públicas de carga',
  'header.homeChargers': 'Catálogos de cargadores domésticos',
  'header.rates': 'Comparar tarifas',
  'header.english': 'Inglés',
  'header.spanish': 'Español',
  'header.faq': 'Preguntas frecuentes',
  'homepage.vehicleCarousel.title':
    'Hay más vehículos eléctricos que nunca. Descubre el tuyo.',
  'homepage.vehicleCarousel.subTitle':
    'Compara el costo de tu elección con el de un vehículo de gasolina similar. Un EV puede ahorrarte dinero, ya que puede ser menos costoso de adquirir y mantener que un coche 100 % de gasolina.',
  'homepage.vehicleCarousel.findEVButton': 'Ver todos los vehículos',
  'homepage.incentives': 'Maximizar los incentivos',
  'homepage.compare': 'Explora ser propietario de un EV',
  'homepage.rates': 'Comparar tarifas',
  'homepage.charging': 'Buscar carga',
  'homepage.browse': 'Buscar EV',
  'homepage.browse.mobile': 'Descubrir {lineBreak} EV',
  'homepage.vehicleCarousel.compareVehiclesButton':
    'Encuentra tu vehículo eléctrico',
  'homepage.faq.title.questions':
    'Preguntas sobre EV, <highline>respondidas.</highline>',
  'homepage.faq.subtitle':
    'Encuentra respuestas a preguntas frecuentes sobre EV relacionadas con carga, incentivos, vehículos y mucho más.',
  'vehicles.new': 'Nuevo',
  'vehicles.used': 'Usado',
  noResults: 'no se encontraron resultados',
  cheaperTo: 'más barato',
  moreExpensive: 'más caro',
  'vehicle.year': 'Año',
  'graph.assumptions': 'Supuestos',
  'graph.graphValues': 'valores de la gráfica',
  'graph.show': 'Mostrar',
  'graph.hide': 'Ocultar',
  'graph.moreExpensive': 'cuesta más',
  'graph.cheaper': 'más barato',
  'graph.beCheaper': 'sera más barato',
  'graph.toOwnOver': 'de mantener durante',
  'graph.years': 'años',
  'graph.year': 'Año',
  'graph.costOfOwnership.title': 'Costo de ser propietario',
  'graph.costOfOwnership.subTitle':
    'El {carName} {costDeltaText} {costDeltaTextEnding}',
  'graph.costOfOwnership.subTitleThreeCars':
    'El {carName} es el más barato para poseer durante {yearsOfOwnership} años',
  'graph.costOfOwnership.whyDifferentCost': '¿Por qué es diferente el costo?',
  'graph.costOfOwnership.showCostBreakdown': 'Mostrar desglose de costos',
  'graph.costOfOwnership.descriptionRow.vehicle': 'Vehículo',
  'graph.costOfOwnership.descriptionRow.maintenance': 'Mantenimiento',
  'graph.costOfOwnership.descriptionRow.insurance': 'Seguros',
  'graph.costOfOwnership.descriptionRow.electricity': 'Electricidad',
  'graph.costOfOwnership.descriptionRow.gasoline': 'Gasolina',
  'graph.costOfOwnership.totalRow': 'Total',
  'graph.costOfOwnership.description': 'Descripción',
  'graph.costOfOwnership.chart.vehicle': 'Pagos del vehículo',
  'graph.costOfOwnership.chart.electricity': 'Electricidad',
  'graph.costOfOwnership.chart.gasoline': 'Gasolina',
  'graph.costOfOwnership.chart.maintenance': 'Mantenimiento',
  'graph.costOfOwnership.chart.insurance': 'Seguros',
  'graph.title.costAnalysis': 'Análisis de costos',
  'graph.title.speedOfCharge': 'Autonomía eléctrica',
  'graph.title.electricRange': 'Autonomía eléctrica',
  'graph.monthlyCostToFill.title': 'Costo por llenarlo mensualmente',
  'graph.speedOfCharge.levelTwoChargingSpeed':
    'Velocidad del cargador de nivel 2',
  'graph.speedOfCharge.fastChargingSpeed': 'Velocidad de carga rápida',
  'graph.speedOfCharge.mphLevelTwoCharger':
    'millas por hora con un cargador de nivel 2',
  'graph.speedOfCharge.thirtyFastCharge':
    'millas por 30 minutos de carga rápida',
  'graph.speedOfCharge.subTitle':
    'El {car} se carga {number} {costDeltaText} {subTitleText}',
  'graph.speedOfCharge.mphLevelTwoChargerThreeCars':
    'carga la mayor cantidad de millas por hora con un cargador de nivel 2',
  'graph.speedOfCharge.thirtyFastChargeThreeCars':
    'carga la mayor cantidad de millas por 30 minutos de carga rápida',
  'graph.speedOfCharge.subTitleThreeCars': 'El {car} {subTitleText}',
  'graph.speedOfCharge.mphLevelTwoChargerTitle':
    'Cantidad de carga por hora de carga de nivel 2',
  'graph.speedOfCharge.fastChargerTitle':
    'Cantidad de carga por 30 minutos de carga rápida',
  'graph.electricRange.subTitleThreeCars':
    'El {car} tiene la mayor autonomía eléctrica.',
  'graph.electricRange.subTitle':
    'La autonomía eléctrica del {car} es {costDeltaText} por {number} millas',
  'graph.electricRange.gasolineRange': 'Gasolina',
  'graph.monthlyCostToFill.subTitle':
    '{carName} es {style} {costDeltaText} al combustible mensualmente',
  'graph.monthlyCostToFill.subTitleThreeCars':
    'Mensualmente, el {carName} es el más barato en cuanto a combustible.',
  'evs.incentivesScoreOptions': 'Filtros de elegibilidad',
  'evs.includeCharger': 'Incluir el costo del cargador',
  'evs.includeChargerTooltip':
    'Incluye $1,800 para cubrir los costos de adquisición e instalación de un cargador doméstico de nivel 2',
  'evs.vehicleAge': 'Antigüedad del vehículo',
  'ev.used.yearRange': 'Rango de años',
  'inventory-filter.filter-vehicles': 'Filtros',
  'inventory-card.vehicle-details': 'Ver detalles',
  'evs.availableNowTooltip':
    'Los vehículos disponibles actualmente se pueden comprar para entrega inmediata, en lugar de estar disponibles solo para pedidos anticipados. El inventario real puede variar según la ubicación.',
  compare: 'Comparar',
  FAQ: 'PREGUNTAS FRECUENTES',
  events: 'Eventos',
  home: 'Hogar',
  'inventory-dealers-filter.shop-dealers': 'Tiendas distribuidoras',
  'graph.community': 'Comunidad',
  'graph.yourEV': '(Tu selección)',
  'graph.similarGasVehicle': '(vehículo de gasolina similar)',
  'evs.graph.disclaimer':
    'Los vehículos mostrados pueden no reflejar la disponibilidad real. {companyName} no respalda ni recomienda ningún vehículo o fabricante de automóviles específico.',
  'evs.graph.title': 'Vehículos eléctricos',
  'evs.graph.compare':
    'Compara coches eléctricos por autonomía o precio de EV. Mueve el ratón sobre el EV para obtener más detalles.',
  'evs.graph.mobile':
    'Para ver la gráfica de autonomía versus costos, mira esta página en una computadora de escritorio.',
  'evs.graph.tiles': 'Cuadros de vehículos',
  'evs.graph.rangeVsCost': 'Autonomía versus costo',
  'graph.fuelRange.chart.description': 'Descripción',
  'graph.fuelRange.chart.rangeOn': 'Autonomía en',
  'graph.fuelRange.chart.fuelBudget': 'presupuesto de combustible',
  'graph.fuelRange.chart.network': 'en la red Plug-In EVerywhere',
  'graph.fuelRange.chart.unlimited': 'Ilimitado',
  'graph.fuelRange.chart.chargedHome': 'cargado en casa',
  'graph.fuelRange.chart.similarGas': 'un vehículo de gasolina similar',
  'graph.fuelRange.chart.miles': 'millas',
  'graph.fuelRange.chart.howFar':
    '¿Hasta dónde puedes conducir el {car} con un presupuesto de combustible de {budget}?',
  'graph.title.miles': 'Millas',
  'graph.title.totalRange': 'Autonomía total',
  'graph.costVsRange.afterIncentives': 'Desde {price} después de incentivos',
  'graph.costVsRange.electricRange': 'Autonomía eléctrica: {miles} millas',
  'graph.electricRange.electricity': 'Electricidad',
  'graph.electricRange.gasoline': 'Gasolina',
  'graph.electricRange.total': 'Total',
  'graph.electricRange.description': 'Descripción',
  'graph.showCostBreakdown': 'Mostrar desglose de costos',
  'graph.costDifferent': '¿Por qué es diferente el costo?',
  'graph.costToBreakdown': 'Costo de una avería',
  'graph.costToBreakdown.subTitle':
    'El {car1} no es actualmente más barato de poseer que el {car2}',
  'graph.costToBreakdown.subTitleCheaper':
    'El {car1} se vuelve más barato después de {time}',
  'graph.costToBreakdown.subTitleAlwaysCheaper':
    'El {car1} es actualmente más barato de poseer que el {car2}',
  'graph.costToBreakdown.subTitleThreeCars':
    'Compara el costo acumulativo durante la vida útil del {car1}, el {car2} y el {car3}',
  'graph.costToBreakdown.note':
    'Nota: La gráfica de costos igualados asume que los vehículos se compran en efectivo.',
  'homepage.incentives.title':
    'Maximizar los posibles incentivos para ev y créditos fiscales.',
  'homepage.incentives.subTitle':
    'Descubre cuánto podrías ahorrar conduciendo un EV, ya sea que lo compres o que lo alquiles. Los incentivos se personalizan según el lugar donde vivas.',
  'homepage.incentives.exploreIncentives': 'Personalizar los incentivos',
  'compareVehicles.subTitle':
    'Elige al menos dos vehículos para empezar la comparación.',
  'compareVehicles.selectFuelTitle': 'Tipo de combustible',
  'compareVehicles.selectMakeTitle': 'Marca del vehículo',
  'compareVehicles.selectModelTitle': 'Modelo del vehículo',
  'compareVehicles.pickTwo':
    'Elige al menos 2 vehículos para iniciar la comparación',
  'compareVehicles.disclaimer':
    'No todas las marcas/modelos están disponibles.',
  'ev.matchScore.title': 'Resultado de la comparación',
  'ev.filters.button.title': 'Filtros abiertos',
  'evs.buttonMatchScoreAndFilters': 'Filtros',
  'evs.matchScoreAndFilters': 'Filtros',
  'evs.matchScoreOptions': 'Filtros',
  'evs.vehicleAgeTooltip':
    'El año del modelo más recientemente lanzado aparecerá en Nuevo. Para todos los modelos de años anteriores, seleccione Usado.',
  'evs.incentivesFilterHeader': 'Filtros de elegibilidad',
  'evs.incentivesVehicleOptions': 'Vehículo eléctrico considerado',
  'evs.roundTripCommute': 'Autonomía',
  'evs.budgetAfterIncentives': 'Presupuesto después de los incentivos',
  'evs.minSeats': 'Cantidad mínima de asientos',
  'evs.seats': 'asientos',
  'evs.levelOne': 'Nivel 1',
  'evs.levelTwo': 'Nivel 2',
  'evs.helpMeChoose': 'Ayúdame a elegir',
  'evs.chargingAvailability': 'Disponibilidad de carga',
  'evs.disclaimer':
    'Los vehículos mostrados pueden no reflejar la disponibilidad real. {company} no respalda ni recomienda ningún vehículo o fabricante de automóviles específico.',
  'chargingWizard.carOvernight':
    '¿Dónde vas a estacionar tu coche por la noche?',
  'chargingWizard.parkingGarage': 'Garaje privado o plaza de estacionamiento',
  'chargingWizard.onTheStreet': 'En la calle',
  'chargingWizard.publicParking': 'Estacionamiento público',
  'chargingWizard.electricianInstall':
    '¿Se le permitiría a un electricista instalar una estación de carga?',
  'chargingWizard.overnightParking':
    '¿Podrías estacionar el coche por la noche en un lugar equipado con una estación de carga?',
  'chargingWizard.powerOutlet':
    '¿Hay alguna toma de corriente regular cerca de donde estacionas tu coche?',
  'chargingWizard.noChargingAvailability': 'sin disponibilidad de carga',
  'chargingWizard.useThisValue': 'Utiliza este valor',
  evfilter: 'Filtro',
  'evfilter.fuel': 'Combustible',
  'evfilter.fuelTooltip':
    'Los vehículos totalmente eléctricos solo utilizan electricidad. Los híbridos enchufables pueden utilizar electricidad y gasolina.',
  'evfilter.type': 'Tipo',
  yes: 'Sí',
  no: 'No',
  'evCard.electricRange': 'Autonomía eléctrica',
  'evCard.totalRange': 'Autonomía total',
  'evCard.seeDetails': 'Ver detalles',
  'evSort.title': 'Ordenar por',
  'evSort.electricRange': 'Autonomía eléctrica',
  'evSort.priceLtH': '$: De bajo a alto',
  'evSort.priceHtL': '$: De alto a bajo',
  'evSort.aToZ': 'Marca: de la A a la Z',
  'evSort.zToA': 'Marca: de la Z a la A',
  'pricePanels.cash': 'Efectivo',
  'pricePanels.loan': 'Préstamo',
  'pricePanels.lease': 'Alquiler',
  'pricePanels.downPayment': 'Pago inicial',
  'pricePanels.perMonth': '/mes',
  'ev.carDetails.view': 'Ver detalles del vehículo',
  'ev.carDetails.calc.charging': 'Cargando',
  'ev.carDetails.calc.fuel': 'Combustible',
  'ev.carDetails.calc.emissions': 'Emisiones',
  'ev.carDetails.calc.description': 'Descripción',
  'ev.carDetails.calc.source': 'Fuente',
  'ev.carDetails.calc.DCFC': 'Tasa de carga rápida en DC (DCFC)',
  'ev.carDetails.calc.kwPerMile': 'kWh por 100 mi',
  'ev.carDetails.calc.milesDriven': 'Millas recorridas al año',
  'ev.carDetails.calc.milesPerGallonBasic': 'Millas por galón',
  'ev.carDetails.mobile':
    'Para obtener más detalles, incluidas gráficos y cálculos {amp}, consulta esta página en una computadora de escritorio.',
  'ev.carDetails.fastChargingTooltip': 'Velocidad del cargador rápido en DC:',
  'ev.carDetails.levelTwoChargerSpeedTooltip':
    'Velocidad del cargador de nivel 2:',
  'ev.carDetails.treesPlanted': 'Árboles plantados',
  'ev.carDetails.gasolineSaved': 'Gasolina ahorrada',
  'ev.carDetails.compareText':
    '* Seleccionamos el {gasVehicle} basándonos en su proximidad al {vehicle} en función de la marca, el tamaño y el precio.',
  'ev.cardetails.calc.dcRate': 'Tasa de carga rápida en DC (DCFC)',
  'ev.cardetails.calc.EPA': 'Calificación de eficiencia EPA',
  'ev.cardetails.calc.chargingRate': 'Tasa de carga',
  'ev.cardetails.calc.vehicleBatteryCapacity':
    'Capacidad de la batería del vehículo',
  'ev.cardetails.calc.emissionsReductions': 'Reducción de emisiones',
  'ev.cardetails.calc.maxACIntake': 'Entrada máxima de AC del vehículo',
  'ev.cardetails.calc.lvlTwoChargingRate': 'Tasa de carga de nivel 2',
  'ev.cardetails.calc.minOflvl2AC':
    'Mínimo de tasa de carga de nivel 2 y entrada máxima de AC del vehículo',
  'ev.cardetails.calc.lvl2FullCharge':
    'Tiempo que tarda en cargarse completamente en el nivel 2',
  'ev.cardetails.calc.milesDrivenPerYr': 'Millas recorridas al año',
  'ev.cardetails.calc.userInput': 'Entrada del usuario',
  'ev.cardetails.calc.milesPerGallon': 'Millas por galón (MPG)',
  'ev.cardetails.calc.mpg': 'millas/galón',
  'ev.cardetails.calc.portionElectric': 'Porción de conducción eléctrica',
  'ev.cardetails.calc.portionElectricSource':
    'Entrada del usuario. Para un vehículo híbrido, calcula la cantidad de millas recorridas utilizando la batería eléctrica en lugar de gasolina.',
  'ev.cardetails.calc.gallonsUsed': 'Galones utilizados',
  'ev.cardetails.calc.gallonsUsedFormula':
    'Millas recorridas * (1 - Porción de conducción eléctrica) / MPG',
  'ev.cardetails.calc.gallonsSaved': 'Galones ahorrados',
  'ev.cardetails.calc.gallonsSavedFormula':
    'Galones utilizados por un vehículo de gasolina equivalente - Galones consumidos por un EV',
  'ev.cardetails.calc.electricEmissions': 'Emisiones eléctricas en libras',
  'ev.cardetails.calc.electricEmissionsLbsMwh':
    'Emisiones eléctricas en libras/MWh',
  'ev.cardetails.calc.EIA':
    'Administración de Información Energética de EE. UU',
  'ev.cardetails.calc.gasolineEmissionsYr':
    'Emisiones de gasolina en libras de CO2/año',
  'ev.cardetails.calc.gasolineEmissions':
    'Emisiones de gasolina en libras por galón',
  'ev.cardetails.calc.emissionsReudctions': 'Reducción de emisiones',
  'ev.cardetails.calc.lbsCo2PerYr': 'libras de CO2 al año',
  'ev.cardetails.calc.gasolineEmissionsLbs': 'Emisiones de gasolina en libras',
  'ev.cardetails.calc.arborDayFoundation': 'Arbor Day Foundation',
  'ev.cardetails.calc.emissionsPerTree': 'Emisiones ahorradas por árbol',
  'ev.cardetails.calc.electricityEmissions':
    'Emisiones eléctricas en CO2 libras/MWh',
  'ev.usedCarTitle': '{car} usado',
  'ev.cardetails.electricRange':
    'Para tener en cuenta la degradación de la batería, la autonomía citada aquí es una estimación basada en la edad del vehículo y en los patrones normales de conducción/carga.',
  'ev.carDetails.usedBatterySizeTooltip':
    'Un kilovatio-hora (kWh) es energía suficiente para recorrer de 1 a 4 millas, según el vehículo. Para tener en cuenta la degradación de la batería de un EV usado, el tamaño de la batería citada aquí es una estimación basada en la edad del vehículo y en los patrones normales de conducción/carga.',
  timeToCharge:
    'Supone la carga estando totalmente vacío con un cargador promedio de tamaño mediano de nivel 2 (7.7 kW). Nota: Los cargadores de nivel 2 requieren un enchufe de 240 V. Los tiempos de carga del nivel 1 son mucho más largos.',
  batterySize:
    'Un kilovatio-hora es energía suficiente para recorrer de 1 a 4 millas, según el vehículo. Como referencia, la batería de una computadora portátil regular puede contener menos de 0.1 kWh.',
  rangeMap:
    'Como lo anuncia el fabricante. La autonomía real puede variar en función de factores ambientales, el comportamiento al conducir, el mantenimiento del vehículo y la edad de la batería.',
  minimumRangeTooltipDaily:
    'Según la {fha}, el promedio de millas diarios por conductor en Estados Unidos es inferior a 60.',
  'evSort.alphabeticaldesc': 'Marca: de la A a la Z',
  'evSort.alphabeticalasc': 'Marca: de la Z a la A',
  'evSort.chargeasc': 'Velocidad de carga',
  'incentiveCard.seeMore': 'Conocer más',
  'incentiveSort.largest': 'El más grande primero',
  'incentiveSort.aToZ': 'Por orden alfabético: de la A a la Z',
  'incentiveSort.zToA': 'Por orden alfabético: de la Z a la A',
  'incentives.electricityProvider': 'Proveedor de electricidad',
  'ev.jumbotron.seeIncentives': 'Ver los incentivos',
  'ev.purchaseMethod': 'Método de pago',
  'ev.purchaseMethodToolTip':
    'En un leasing, tienes que devolver el coche después del periodo de alquiler. En el caso de financiación mediante préstamo, te quedas con el coche una vez pagado el préstamo.',
  'incentives.retiringVehicleTooltip':
    'Para ciertos incentivos, puede ser necesario retirar un vehículo antiguo de gasolina.',
  'incentives.householdIncome': 'Ingresos familiares',
  'incentives.householdIncomeTooltip':
    'Combina los ingresos de todos los miembros del hogar. Se utiliza para determinar la elegibilidad para los incentivos.',
  'incentives.tradeIn': '¿Retirar un vehículo?',
  'incentives.householdSize': 'Número de integrantes del hogar',
  'incentives.taxFilingStatus': 'Situación fiscal',
  'incentives.taxFilingStatusTooltip':
    'Se utiliza para determinar la elegibilidad para los incentivos.',
  'incentives.householdSizeTooltip':
    'Incluye a todos los miembros de tu hogar (cónyuge, dependientes, etc.). Se utiliza para determinar la elegibilidad para los incentivos.',
  modal1:
    '¿Cuál es el cargo promedio por la electricidad en tu factura mensual?',
  modal2: 'Paso',
  'modal3.of': 'de',
  modal4: 'Siguiente',
  modal5: '¿Qué EV ya tienes o quieres comprar/tomar en leasing?',
  modal6: 'Pista: Puedes ajustar estos filtros después de ver los resultados.',
  modal7:
    'Elige tu EV actual o preferido para ver el ahorro potencial en diferentes planes de precios. La selección del vehículo influye en el ahorro potencial de la factura eléctrica debido a las diferencias de rendimiento y eficiencia eléctrica entre los distintos modelos.',
  modal8: 'Anterior',
  modal9: 'En promedio, ¿cuántas millas conduces al año?',
  modal10: 'Pista: Un conductor típico recorre unas 12,000 millas al año.',
  modal13: 'Todas las horas',
  modal14: '¿Cuál es tu plan de precios actual?',
  modal15:
    'Pista: La mayoría de los clientes tienen la tarifa hora del día (TOD) (de 5 a 8 p. m.)',
  modal16:
    'Nota: En el caso de los clientes con la tarifa Hora del día (TOD) (de 5 a 8 p. m.), suponemos que actualmente conducen vehículos de gasolina de tipo, marca y precio similares a los del EV seleccionado en el paso 2 y mostramos el ahorro que supondría cambiar a este EV.',
  hcaCarMake: 'Marca de EV considerada',
  hcaCarModel: 'Modelo de EV considerado',
  hcaWhenWillYouCharge: 'Patrón de carga',
  'rateAdvisor.rateComparison': 'Comparación de tarifas de ahorro',
  pricingPlan: 'Comparación de planes de precios',
  'rateAdvisor.sub':
    'Descubre cuánto puedes ahorrar con el crédito de la tarifa para EV. Ajusta los parámetros que aparecen a continuación para comparar el ahorro.',
  'rateAdvisor.title': 'Asesor de tarifas',
  hcaCurrentElectricRate: 'Tarifa actual',
  hcaCurrentMonthlyBill: 'Factura mensual de electricidad del hogar',
  drivingAssumptions: 'Supuestos de conducción',
  gasolinePrice: 'Precio de la gasolina',
  conventionalVehicleEfficiency: 'Eficiencia del vehículo de gasolina',
  conventionalVehicleEfficiencyTooltip:
    'Para calcular el posible ahorro, ingresa las millas por galón (MPG) del vehículo de gasolina que deseas reemplazar por un EV totalmente eléctrico o híbrido enchufable.',
  hcaPortionPublicCharging: 'Porción de la carga pública',
  hcaPortionPublicChargingTooltip:
    'Los conductores de EV realizan casi todas sus cargas en casa.',
  costOfPublicCharging: 'Costo de la carga pública',
  costOfPublicChargingTooltip:
    'El precio de la carga en los cargadores públicos de SMUD es de $0.25/kWh. Las otras tarifas de carga pública en el territorio de SMUD varían.',
  changeYourRate: 'Ver opciones de tarifas',
  savingsGraphDisclaimer:
    'Nota: Supongamos que abasteces tu hogar con este plan de precios y que actualmente conduces un vehículo de gasolina con un tipo, marca y precio similares a los del EV que seleccionaste. La tarifa TOD con descuento para EV ofrece el descuento óptimo cuando se carga un EV entre la medianoche y las 6 a. m. {br} {br} * El descuento en la tarifa para EV no está disponible en la tarifa fija.',
  savingsGraphYAxis: 'Costos promedios estimados por año',
  saved: 'guardado',
  'rs.fixed': 'Tarifa fija',
  here: 'aquí',
  'inventory-filter.model-label': 'Modelo de EV',
  'inventory-filter.all': 'Todos',
  'results.updated': 'Los resultados fueron actualizado al',
  'chargingStationsList.station': 'Estación',
  'chargingStationsList.address': 'Dirección',
  'chargingStationsList.type': 'Tipo',
  'chargingStationsList.phone': 'Teléfono',
  vehicleMakeTooltip:
    'Selecciona la marca del vehículo en la que estás interesado.',
  'incentives.selectModel': 'Selecciona la marca',
  'incentives.selectMake': 'Selecciona el modelo',
  'incentives.selectTrim': 'Selecciona la tapicería',
  'evSort.alphabetical': 'Por orden alfabético',
  'homepage.bigPromiseHeader':
    'Ahora es el momento de cambiarse a lo eléctrico.',
  'homepage.bigPromiseParagraph':
    'Calcula y compara costos, ahorros, incentivos y mucho más.',
  'homepage.researchEVs': 'Investigar los EV',
  'homepage.compareVehicles': 'Comparar vehículos',
  'homepage.maximizeIncentives': 'Maximizar los incentivos',
  'homepage.compareEvRates': 'Comparar las tarifas para EV',
  'homepage.findChargingStations': 'Encontrar estaciones de carga',
  'homepage.browseHomeChargers': 'Buscar cargadores domésticos',
  'homepage.browseEvInventory': 'Explorar el inventario de EV',
  'homepage.discoverEvContent': 'Descubrir contenido sobre EV',
  'homepage.discoverEvContentFaq':
    'Descubrir contenido sobre EV y preguntas frecuentes',
  'chargingMap.highPower': 'Solo estaciones de alta potencia',
  'chargingMap.searchCharging': 'Buscar estaciones de carga',
  'charger.disclaimer':
    'Los rangos de kilometraje se basan en estimaciones proporcionadas por los fabricantes de vehículos eléctricos. Su autonomía puede variar según el clima, la región, el tráfico, el modelo del vehículo y las condiciones del automóvil. Los datos del Centro de Datos de Combustibles Alternativos pueden no reflejar la disponibilidad más reciente. Por favor, confirme la disponibilidad de las estaciones de carga antes de iniciar su viaje. Envíe aquí las estaciones de carga que considere que faltan {here}.',
  'homepage.chargingMap.title': 'Ubicaciones de estaciones de carga',
  'homepage.chargingMap.subtitle':
    'Ahora es más fácil que nunca cargar tu vehículo mientras te desplazas. Ingresa tu ubicación para encontrar todas las estaciones de carga cercanas a ti o en tu ruta.',
  'page.chargingMap.title': 'Ubicaciones de estaciones de carga',
  'page.chargingMap.subtitle':
    'Ahora es más fácil que nunca cargar tu vehículo mientras te desplazas. Ingresa tu ubicación para encontrar todas las estaciones de carga cercanas a ti o en tu ruta',
  'modal.allHours': 'Todas las horas',
  'modal.weekend': 'Fin de semana',
  'rateComparison.youAreAlreadySavingVehicleCompared':
    'Ya estás ahorrando hasta {highlightText} al año en {highlight} con un {selectedVehicle} en relación con un vehículo de gasolina comparable.',
  'rateComparison.youAreSavingVehicleCompared':
    'Puedes ahorrar hasta {highlightText}/año cambiándote al {highlight} con un {selectedVehicle} en relación con un vehículo de gasolina comparable.',
  'rateComparison.youAreAlreadySaving':
    'Ya estás ahorrando hasta {highlightText} si tienes un EV y utilizas el plan de tarifas {highlight}.',
  'rateComparison.youAreAlreadySavingVehicle':
    'Ya estás ahorrando hasta {highlightText} al año cambiándote al {highlight} con un {selectedVehicle}.',
  'rateComparison.youAreSavingVehicle':
    'Puedes ahorrar {highlightText} al año cambiándote a {highlight} con un {selectedVehicle}.',
  'rateComparison.youAreSaving':
    'Estás ahorrando hasta {highlightText} si tienes un EV y utilizas el plan de tarifas {highlight}.',
  savingsGraphHomeLabel: 'Uso en casa',
  savingsGraphEVLabel: 'Carga de EV',
  savingsGraphGasLabel: 'Gasolina',
  'ev.perGallon': '/galón',
  'ev.public': 'Público',
  'ev.msrp': 'de MSRP + Impuestos',
  'rs.timeOfDay': 'Tarifa por hora del día',
  filterClosed: 'Ajustar los filtros',
  rateAdvisorfilters: 'Filtros del asesor de tarifas',
  basicFilters: 'Filtros básicos',
  homeAssumptions: 'Supuestos del hogar',
  electricPortion: 'Porción eléctrica',
  'graph.costToBreakdown.subTitleImmediate':
    'En función de tu selección, el {car1} puede ser más barato de poseer desde el principio.',
  'graph.costOfOwnership.chart.charger': 'Cargador',
  'graph.electricRange.assumptions': 'Supuestos',
  'vehicle.electricEfficiency': 'Eficiencia eléctrica',
  'FAQ.title.ev': 'EV',
  'FAQ.title.101': '101',
  'FAQ.sectionTitleOne': '¿Qué es un EV y cómo funciona?',
  'FAQ.bodyOne':
    'Un vehículo eléctrico (EV) es un tipo de vehículo que utiliza electricidad como fuente principal de energía, en lugar de gasolina o diésel. Los EV se han hecho cada vez más populares en los últimos años debido a su potencial para reducir los costos de funcionamiento y las emisiones en comparación con los vehículos de gasolina tradicionales.{lineBreak} Entonces, ¿cómo funciona un EV? Un EV funciona con un motor eléctrico, alimentado a su vez por una batería. La batería almacena electricidad, que se utiliza para alimentar el motor y hacer girar las ruedas del vehículo. Cuando el vehículo está en uso, la batería se agota lentamente. Factores  como el uso de la calefacción o el aire acondicionado y las condiciones de conducción pueden afectar la autonomía. Para recargar la batería, el EV debe enchufarse a una fuente de energía eléctrica, como un enchufe en la pared o una estación de carga pública.{lineBreak} Existen dos tipos principales de EV: vehículos eléctricos de batería (BEV) y vehículos eléctricos híbridos enchufables (PHEV). Los BEV funcionan exclusivamente con electricidad, mientras que los PHEV funcionan tanto con un motor eléctrico como con uno de gasolina. Los PHEV pueden alternar entre las dos fuentes de energía según sea necesario, lo que les permite ampliar su autonomía más allá de lo que es posible solo con electricidad.',
  'FAQ.sectionTitleTwo': 'Carga de EV 101',
  'FAQ.bodyTwo':
    'La carga de EV se clasifica en tres niveles: Nivel 1, Nivel 2 y Nivel 3 (carga rápida en DC o supercarga en estaciones de carga Tesla). Alrededor del 85 % de la carga de EV se realiza en casa con cargadores de Nivel 1 o Nivel 2. {lineBreak} La carga de nivel 1 utiliza un enchufe doméstico estándar de 120 voltios y proporciona la carga más lenta, añadiendo por lo general entre 2 y 5 millas de autonomía por hora para la mayoría de los EV, lo que la hace adecuada para la carga nocturna en casa. Los EV más grandes y pesados tendrán menos millas de autonomía por hora de carga. {lineBreak} La carga de nivel 2 utiliza un enchufe de 240 voltios como los que se utilizan para electrodomésticos grandes. Proporciona una carga más rápida, añadiendo entre unas 10 y 60 millas de autonomía por hora en función de la potencia de salida del cargador y del vehículo que se esté cargando, y se encuentra habitualmente en hogares, lugares de trabajo y estaciones de carga públicas. La instalación de un circuito eléctrico para un cargador de nivel 2 debe ser realizada por un electricista profesional. {lineBreak} Por último, el nivel 3 o carga rápida/supercarga en DC emplea corriente continua (DC) y estaciones de alta potencia (usualmente 400 voltios o más), proporcionando la carga más rápida. Es capaz de añadir entre 60 y 100 millas  de autonomía en tan solo 20 minutos (dependiendo de la capacidad de salida de potencia del cargador) y se utiliza principalmente en entornos comerciales y a lo largo de las autopistas para recargas rápidas.',
  'FAQ.sectionTitleThree': 'Aliviar la ansiedad por la autonomía del EV',
  'FAQ.bodyThree':
    'Los EV varían considerablemente en cuanto a la distancia que pueden recorrer con una sola carga, dependiendo de factores como la capacidad de la batería, la eficiencia del vehículo y las condiciones de conducción. La mayoría de los EV modernos ofrecen una autonomía de entre 200 y 300 millas por carga, y algunos modelos superan las 400 millas. Los avances tecnológicos y las crecientes inversiones en tecnología de baterías están ampliando continuamente estos límites, mejorando la densidad energética y la eficiencia. {lineBreak} Si necesitas cargar en la carretera, cada vez es más fácil encontrar una estación de carga pública para EV gracias a la expansión rápida de la infraestructura de carga. En las zonas urbanas y a lo largo de las autopistas principales, las estaciones de carga son relativamente comunes, con redes como Tesla Superchargers, ChargePoint y Electrify America que ofrecen una cobertura amplia. Muchos EV vienen equipados con sistemas de navegación que incluyen la ubicación de las estaciones de carga, y numerosas aplicaciones para teléfonos inteligentes y sitios web también ayudan a los conductores a localizar cargadores cercanos, verificar su disponibilidad e incluso iniciar sesiones de carga de forma remota. Si bien es posible que las zonas rurales y menos pobladas sigan teniendo menos opciones, el crecimiento continuo del mercado de EV está impulsando una inversión mayor en infraestructura de carga, lo que hace más conveniente para los propietarios de EV encontrar estaciones públicas de carga en diversos lugares.',
  'FAQ.sectionTitleFour':
    'Beneficios de los EV: ambientales, costo y mantenimiento',
  'FAQ.bodyFour':
    'Uno de los beneficios principales de los EV es su potencial para reducir las emisiones. Dado que funcionan con electricidad, que puede producirse de forma limpia, en lugar de combustibles fósiles, no emiten gases por el escape cuando están en uso. Esto los convierte en una alternativa más limpia a los vehículos de gasolina tradicionales. Además, los EV suelen ser más eficientes energéticamente que los vehículos de gasolina, lo que puede reducir aún más su impacto ambiental. {lineBreak} Otra ventaja de los EV es su bajo costo de funcionamiento. Al tener menos piezas móviles que los vehículos de gasolina, suelen requerir menos mantenimiento y, en consecuencia, tienen una vida útil más larga. Además, la electricidad suele ser más barata que la gasolina, por lo que el funcionamiento de un EV puede resultar más rentable a largo plazo. Con el descuento de SMUD en la tarifa para EV, cargar en casa es como pagar $1 por galón de gasolina. También hay varios incentivos y descuentos disponibles para los propietarios de EV, como créditos fiscales federales y reembolsos y subvenciones estatales, acceso al carril HOV y peajes reducidos. Estos incentivos pueden reducir aún más el costo de propiedad.',
  'FAQ.orangeButtonText':
    'Obtén más información sobre nuestros programas de vehículos eléctricos',
  'homeChargers.button':
    'Encuentra otros dispositivos elegibles para el programa Charge@Home de SMUD',
  'homeChargers.title':
    'Selecciona un cargador que se adapte a tus necesidades',
  'homeChargers.subtitle':
    'Explora cargadores para el hogar y encuentra el que mejor se adapte a tu vehículo eléctrico y tus necesidades de carga.',
  apply: 'Presentar una solicitud',
  'ev.filters.title': 'Filtros de análisis de costos',
  minimumRangeTooltip:
    'Calcula qué porcentaje de tus millas recorridas serán completamente eléctricas. {br} Si recargas a diario y conduces menos al día que la autonomía totalmente eléctrica, tu porcentaje estará cerca al 100 %. {br} Para la conducción más habitual, más allá de la autonomía totalmente eléctrica. El 50 % es una suposición segura.',
  'vehicle.carMake': 'Marca del coche',
  'vehicle.timeToCharge':
    'Supone la carga estando totalmente vacío con un cargador promedio de tamaño mediano de nivel 2 (7.7 kW). Nota: Los cargadores de nivel 2 requieren un enchufe de 240 V. Los tiempos de carga del nivel 1 son mucho más largos.',
  'vehicle.c02Emissions':
    'En comparación con un vehículo de gasolina equivalente de marca, tipo y año similares, suponiendo un millaje anual típico de 12,000 millas y teniendo en cuenta las emisiones de su mezcla energética local según los datos de {eia}.',
  'compareVehicles.selectFuel': 'Selecciona el combustible',
  'compareVehicles.selectMake': 'Selecciona la marca',
  'compareVehicles.selectModel': 'Selecciona el modelo',
  'evfilter.all': 'Todos',
  'evfilter.make': 'Marca',
  'rs.timeOfDay.b1':
    'El precio de la electricidad varía según la hora del día en que se utiliza.',
  'rs.timeOfDay.b2':
    'Ahorre en su factura de electricidad conservando energía durante las horas pico (de lunes a viernes, de 5 p. m. a 8 p. m.).',
  'rs.timeOfDay.b3':
    'Ayuda a reducir la carga de la red eléctrica y a promover un medio ambiente más limpio al programar el consumo de energía durante las horas de menor demanda. Al reprogramar el horario en el que utiliza la electricidad, puede ahorrar en su factura y reducir el impacto sobre el medio ambiente.',
  'r14.fixed': 'Tarifa fija',
  'r14.fixedRateComparison':
    'La tarifa fija es, por lo general, un 4 % más alta que la tarifa según la hora del día (de 5 p. m. a 8 p. m.).',
  'r14.priceBySeason': 'El precio de la electricidad se fija por temporada.',
  'r14.sameRateAllDay':
    'Usted paga la misma tarifa eléctrica durante todas las horas del día.',
  'rs.timeOfDayEV':
    'Tarifa según la hora del día (de 5 p. m. a 8 p. m.) con descuento para vehículos eléctricos',
  'rs.timeOfDayEV.body':
    'Al registrar sus vehículos eléctricos en MyAccount, los conductores pueden recibir un descuento adicional de 1.5 ¢ en el consumo general de electricidad entre medianoche y las 6 a. m.',
  'rate.default': '(predeterminada)',
  'rates.tod.title': 'Tarifa según la hora del día',
  'rateDetails.learnMore': 'Más información',
  'rates.fixed.title': 'Tarifa fija *',
  'graph.current': '(Actual)',
  'rates.tod.evdiscount.title': 'Tarifa de TOD con descuento para VEs',
  'tod.title': 'Tarifa según la hora del día (de 5 p. m. a 8 p. m.)',
  'ev.milesDrivenAnnually': 'Millas conducidas por año',
  month: 'mes',
  'Bill Credit': 'Crédito en la factura',
  'Discounted Electric Rate': 'Tarifa eléctrica con descuento',
  Financing: 'Financiación',
  'Free Equipment': 'Equipo gratuito',
  'HOV Lane': 'Carril HOV',
  'Insurance Discount': 'Descuento de seguro',
  'Parking Exemption': 'Exención de estacionamiento',
  'Public Charging': 'Carga pública',
  Rebate: 'Reembolso',
  'Tax Credit': 'Crédito fiscal',
  'Tax Exemption': 'Exención de impuestos',
  'Toll Discount': 'Descuento de peaje',
  'Federal Tax Credit': 'Crédito fiscal federal',
  'Vehicle Retirement': 'Retiro de vehículo',
  'grantor.federal': 'Federal',
  'grantor.state': 'Estatal',
  'grantor.local': 'Local',
  'grantor.smud': 'SMUD',
  'grantor.utility': 'Compañía de servicios públicos',
  'chargingMap.highPowerStations': 'Estaciones de alta potencia',
  'chargingMap.DCChargers': 'Cargadores rápidos de CC',
  'chargingMap.public': 'Estaciones públicas',
  'chargingMap.businessGovernment': 'Cargadores de Nivel 2',
  'chargingMap.otherStations': 'Otras estaciones',
  'chargingMap.privateStations': 'Estaciones privadas',
  'chargingMap.multipleStations': 'Múltiples cargadores disponibles',
  'vehicle.type.suvcrossover': 'Todoterreno / Crossover',
  'evs.availableNow': 'Disponible ahora',
  'ev.carDetails.view.back': 'Todos los vehículos',
  'ev.jumbotron.maximizeIncentives': 'Maximizar incentivos',
  'ev.jumbotron.totalCost': 'Ver el costo total de propiedad',
  'ev.jumbotron.compare': 'Comparar con otros vehículos',
  'ev.carDetails.table.title': 'Especificaciones del vehículo',
  'ev.cash': 'Efectivo',
  'ev.lease': 'Arriendo',
  'ev.loan': 'Préstamo',

  'ev.yearsOwnership': 'Años de propiedad/arriendo',
  'assumption.salesTax': 'Impuesto sobre ventas',
  'assumption.downPayment': 'Pago inicial',
  gasolinePriceLabel: 'Precio de la gasolina ($/gal)',
  'ev.publicPrivateCharging': 'Porcentaje de carga pública',
  'ev.electricityRate': 'Tarifa de electricidad doméstica ($/kWh)',
  'ev.electricityRateCalc':
    'El valor predeterminado de la tarifa eléctrica es el promedio residencial de SMUD con el descuento para vehículos eléctricos en 2025. Los usuarios pueden ajustarlo para explorar diversas opciones de precios.',
  'evs.thirdParty':
    'No avalamos ni recomendamos ningún vehículo o fabricante específico. Los vehículos mostrados pueden no reflejar la disponibilidad real.',
  'inventory.title': 'Explorar inventario cercano',
  'inventory.subTitle': 'Inventario de concesionarios participantes.',
  'incentives.title': 'Incentivos para vehículos eléctricos y cargadores',
  'incentives.subTitle':
    'Podrías ser elegible para varios incentivos, como reembolsos y créditos fiscales para vehículos eléctricos, entre otros beneficios. Ajusta los filtros para ver resultados personalizados. Recuerda que debes completar todos los campos de “Estado de vivienda y fiscal” e “Información de compra” para obtener una estimación del total de incentivos que podrías recibir.',
  'ev.electricPortion': 'Porción eléctrica para PHEV',
  'incentiveCard.more': 'Más información',
  'ev.compareGasVehicle':
    'Compara el {year} {car} con un vehículo de gasolina similar.',
  'ev.compareGasVehicle.tooltip':
    'Seleccionamos el {gasCar} según su cercanía al {car} en marca, tamaño y precio.',
  'chargingMap.showFullListOfStations': ' lista completa de estaciones',
};

export default esp;
